
import { UserDataV2 } from "@/models/Users";
import { Api } from "@/services";
import { useState } from "react";
import { useUsersContext } from "@/contexts/userContext";

export function useUsers() {
  const baseUrl = "/sellers/authenticated";
  const baseUrlProfile = "/app/v1/users";
  const [loading, setLoading] = useState(false);
  const { setUsers } = useUsersContext();
  const getUsers = async () => {

    try {
      setLoading(true);
      const response = await Api.get(`${baseUrlProfile}`);
      setUsers(response.data);
      return response.data;
    } catch (error) {

      throw new Error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };


  const createUser = async (data: UserDataV2) => {
    try {
      const response = await Api.post(`${baseUrlProfile}`, data);
      await getUsers();
      return response;
    } catch (error) {
      throw new Error("Failed to create user");
    }
  };
  const getListProfiles = async () => {
    try {
      const response = await Api.get(`${baseUrlProfile}/profiles`);
      const profilesFormatted = response.data.map((item: any) => ({
        label: item.label,
        value: item.profile,
      }));
      return profilesFormatted;
    } catch (error) {
      throw new Error("Failed to fetch profiles");
    }
  };

  const getUser = async (userId: number) => {
    try {
      const response = await Api.get(`${baseUrlProfile}/${userId}`);
      return response;
    } catch (error) {
      throw new Error("Failed to update user");
    }
  };

  const updateUser = async (userId: number, data: Partial<UserDataV2>) => {
    try {
      const response = await Api.patch(`${baseUrlProfile}/${userId}`, data);
      await getUsers();
      return response;
    } catch (error) {
      throw new Error("Failed to update user");
    }
  };
  const deleteUser = async (userId: number) => {
    try {
      const response = await Api.delete(`${baseUrl}/users/${userId}`);
      await getUsers();
      return response;
    } catch (error) {
      throw new Error("Failed to delete user");
    }
  };

  return {
    getUsers,
    createUser,
    getUser,
    deleteUser,
    getListProfiles,
    updateUser,
    loading,

  };
}